import angular from 'angular';

const template = `
<div id="sidebar_toggle" class="button_simple" tn-sidebar-toggle="tn-sidebar-toggle">
<a ng-click="$ctrl.toggleSidebar();">
    <span class="icon-arrow-left"></span>
    <label class="sidebar_toggle_closed">Show {{$ctrl.$state.current.data.sidebar.toggle}}</label>
    <label class="sidebar_toggle_open">Hide {{$ctrl.$state.current.data.sidebar.toggle}}</label>
</a>
</div>
`;

export class SidebarToggleController {
    static $inject = ['$rootScope', '$state'];
    constructor(public $rootScope, public $state) {}

    toggleSidebar() {
        const isActive =
            this.$rootScope.pageWrapperCssClasses.indexOf(
                'sidebar_is_active'
            ) !== -1;
        if (isActive) {
            this.closeSidebar();
        } else {
            this.openSidebar();
            angular.element('#main').one('click', (event) => {
                event.stopPropagation();
                this.closeSidebar();
            });
        }
    }

    closeSidebar() {
        angular.element('#main').off('click');
        this.$rootScope.pageWrapperCssClasses.splice(
            this.$rootScope.pageWrapperCssClasses.indexOf('sidebar_is_active'),
            1
        );
    }

    openSidebar() {
        this.$rootScope.pageWrapperCssClasses.push('sidebar_is_active');
    }
}

export const sidebarToggleComponent = {
    template,
    controller: SidebarToggleController,
};
